import axios from 'axios'
import { getLocalTimezone } from 'lib/time'
import { getAuth } from 'firebase/auth'
import { config } from 'config'
import { stringify } from 'qs'
import { STORED_COMPANY_ID_KEY } from '../constants'
import { parseResponseData } from './responseMiddleware'
import { parseErrorMessage } from './errorMiddleware'

export const apiDateFormat = 'yyyy-MM-dd'

const WORKWHILE_COMPANY_HEADER = 'X-Workwhile-Company-Id'

export const api = axios.create({
  baseURL: config.apiHostUrl,
  paramsSerializer: (params) =>
    /** Converts array params to `arr[]=1&arr[]=2` */
    stringify(params, { arrayFormat: 'brackets', indices: false }),
})

api.defaults.headers.common['content-type'] = 'application/json'
api.defaults.headers.common.Accept = 'application/json'
api.defaults.headers.common.Timezone = getLocalTimezone()
api.defaults.headers.common['APP-SOURCE'] = 'bizportal'

// this method ensures that the auth token is always up-to-date
export async function getAuthToken(forceRefresh = false) {
  return new Promise<string | null>((resolve) => {
    const unsubscribe = getAuth().onIdTokenChanged(async (user) => {
      if (user) {
        const token = await user.getIdToken(forceRefresh)
        resolve(token)
      } else {
        resolve(null)
      }
      unsubscribe()
    })
  })
}

api.interceptors.request.use(async (config) => {
  const idToken = await getAuthToken()
  if (idToken) {
    config.headers.Authorization = `Bearer ${idToken}`
  }

  const companyId = localStorage.getItem(STORED_COMPANY_ID_KEY)
  if (companyId) {
    config.headers[WORKWHILE_COMPANY_HEADER] = companyId
  }

  return config
})

api.interceptors.response.use(parseResponseData, parseErrorMessage)
